import { Component, OnInit } from '@angular/core';
import { UserUtilService } from 'src/app/core/services/common/user-util.service';

@Component({
  selector: 'app-sbd',
  templateUrl: './sbd.component.html',
  styleUrls: ['./sbd.component.scss']
})
export class SbdComponent implements OnInit {

  constructor(public userUtilsService:UserUtilService) { }

  ngOnInit(): void {
  }

}
